var sec2date = function(sec, options) {
    options = options || {}
    options.dateFromNow = options.dateFromNow || true
    options.withoutYear = options.withoutYear || false

    var time = new Date(sec * 1000)
      , date = ''

    if (options.dateFromNow) {
      var dateFromNow = getDateFromNow(time)
      if (dateFromNow) { return dateFromNow }
    }

    if (!options.withoutYear) {
      date = time.getFullYear() + '-'
    }

    date += (time.getMonth() + 1) + '-'
      + time.getDate()
    return date
  }
, getDateFromNow = function(time) {
    var now = +(new Date())
      , diff = (now - time)
      , result = ''

    var days = Math.floor(diff / 86400000)

    if (days > 9) {
      return
    }

    var second = Math.floor(diff / 1000)

    if (second < 60 * 3) {
      return '刚刚'
    }

    var minutes = Math.floor(second / 60)

    if (minutes < 60) {
      return minutes + '分钟前'
    }

    var hours = Math.floor(minutes / 60)

    if (hours < 24) {
      return hours + '小时前'
    }

    return days + '天前'
  }
, toFuture = function(sec, options) {
    var date = new Date()
      , now = date.getTime()
      , millisec = date.setTime(sec * 1000)
      , diff = millisec - now
      , txt = options.txt || ''
      , norShowTxt = options.norShowTxt || false

    var second = Math.floor(diff / 1000)
    if (second < 60) {
      return diff + '秒后' + txt
    }

    var minutes = Math.floor(second / 60)
    if (minutes < 60) {
      return minutes + '分钟后' + txt
    }

    var hours = Math.floor(minutes / 60)
    if (hours < 24) {
      return hours + '小时后' + txt
    }

    var y = date.getFullYear()
      , m = date.getMonth() + 1
      , d = date.getDate()
    m = m < 10 ? ('0' + m) : m
    d = d < 10 ? ('0' + d) : d
    if (norShowTxt) {
      return y + '-' + m + '-' + d + txt
    }
    return y + '-' + m + '-' + d
  }
, normal = function(timeStamp) {
  var date = new Date();
  date.setTime(timeStamp * 1000);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  return y + '-' + m + '-' + d;
}

module.exports = {
  sec2date: sec2date
, toFuture: toFuture
, normal: normal
}
